var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order)?_c('b-badge',{attrs:{"variant":_vm.variant}},[_vm._v("\n  "+_vm._s(_vm._f("titleize")(_vm.status))+"\n")]):_c('b-badge',[_c('i',{staticClass:"fa fas fa-spin fa-spinner"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e5c7cbd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/src/components/utility/CondensedStatus.vue
// module id = null
// module chunks = 